import api from '@api/endpoints';
import { setAlert } from '@store/actions/alertActions';
import { ALERT_STATUS_TYPE } from '@constants';

export const getAllUaeManualPaymentsInLastTenMinutes =
  ({ onSuccess, onComplete, onError }) =>
  async (dispatch) => {
    try {
      const { data } =
        await api.uaeManualPayments.getAllPaymentsInLast10Minutes();
      onSuccess && onSuccess(data);
    } catch (error) {
      onError && onError();
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };
